import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { RestS } from "../../rest/rest-service";
import { aggregationFns } from "@tanstack/table-core";

const INITIAL_STATE = {
  accessTokens: [],
  error: {},
  isInProgress: false,
};

export const fetchAccessTokens = createAsyncThunk(
  "accessTokens/fetch",
  async (companyId: string, { rejectWithValue }) => {
    try {
      const response: any = await RestS.getUserAccessTokensByUserId(
        Number(companyId)
      );
      return response;
    } catch (err) {
      return rejectWithValue(err ? err : "something went wrong");
    }
  }
);

const accessTokens = createSlice({
  name: "accessTokens",
  initialState: INITIAL_STATE,
  reducers: {
    updateAccessTokens: (state, action) => {
      state.accessTokens = action.payload.data;
    },
    addAccessTokens: (state, action) => {
      const temp = new Set(state.accessTokens);
      temp.add(action.payload.data);
      state.accessTokens = Array.from(temp);
    },
    deleteAccessTokens: (state, action) => {
      const temp = new Set(state.accessTokens);
      temp.delete(action.payload.data);
      state.accessTokens = Array.from(temp);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAccessTokens.fulfilled, (state, action) => {
      state.accessTokens = action.payload;
    });
  },
});

export const { updateAccessTokens, addAccessTokens, deleteAccessTokens } =
  accessTokens.actions;
export const AccessTokens = accessTokens.reducer;
